import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

/**
 *
 * Simple Modal Header Component
 *
 * Input Properties:
 *
 *  header: The text to use for the header
 *  resetModalText: The text to use for the reset button
 *  showUnsavedStatus: Whether or not to show '(edited)' in the header
 *  selectedObject: A RadioButton (no label necessary) representing the selected value.
 *  extraCssClasses: optional CSS classes to assign to header
 *  customIcon: optional name of icon to display to the left of the header text. Should be a valid YCharts icon name.
 *  customIconClasses: optional CSS classes to assign to the custom icon
 *  showBackButton: Whether or not to show the back button
 *  showCloseButton: Whether or not to show the close (X) button. By default, this is true.
 *
 *
 * Output Properties:
 *
 *  closeModalHandler: EventEmitter that emits when the user hits the X button
 *  resetModalHandler: EventEmitter that emits when the user hits the reset button
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-simple-modal-header',
    templateUrl: './simple-modal-header.template.html',
})
export class SimpleModalHeaderComponent implements OnInit {
    @Input() header!: string;

    @Input() showBackButton: boolean = false;

    @Input() showCloseButton: boolean = true;

    @Input() resetModalText?: string;

    @Input() showUnsavedStatus?: boolean;

    @Input() extraCssClasses?: string;

    @Input() customIcon?: string;

    @Input() customIconClasses?: string;

    @Output() closeModalHandler = new EventEmitter<void>();

    @Output() resetModalHandler = new EventEmitter<string>();

    @Output() back = new EventEmitter();

    @Input({ required: false }) customHeaderFragment: TemplateRef<unknown> | null = null;

    showCloseModalHandler = false;

    showResetModalHandler = false;

    ngOnInit(): void {
        this.showCloseModalHandler = this.closeModalHandler.observers.length > 0;
        this.showResetModalHandler = this.resetModalHandler.observers.length > 0;
    }
}
